module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAABYElEQVQ4T5XSz4vOURiG8c+9VX41smGysJmNSZSiZoXFbCZkYaUU/gBWYjHRSLJklJpEUhaykcKIlJJkZyGlhI2tJDaPzvS+07fxMt6zO51zPed+znPFklVV23AYW7AOH/Eac0m+dK+nv6mqtbiK/ZjHA3zDRkxhK2aSnOszC3BVrcYL/MShJO8HJNqDm61okqPtvA/fxSZMJPmxFOyk29xr4XSS2VTVdrzC2KAXByQ4gosYbfAs1ic5+LcXBxT4imMNfolbSS4PAd9vf9Tgt7iU5PoQ8G28a/BDPE8yMwT8CE8aPI3dSSb+B66qFWg9TzV4Q8+iySSPlytQVedxIMlYf85ncRy7knz4x5z34R72Jpnv6nkDkziJO0l+deRYgxM4szCiZG7RsM6lBp5CA9/gO0awA5/QIo8mufAH3PN8ZYvVVMUqfMazJE+rqunZvLiSZHox9nIf1Um3E9cw/hvC6ZAFn2nw1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/search.png
// module id = tsgT
// module chunks = 2